module.exports = __webpack_public_path__ + "static/assets/91c5fa4689392dff5c308d48d674f5fa.gif";